import type {
  RecommendationDecisionActionTypeDto,
  RecommendationDecisionRequestDto,
} from '../models/orpheus.dto'
import type { ChatThread, Recommendation } from '../models/orpheus.types'

export interface RecommendationDecisionIntent {
  accepted: boolean
  recommendation: Recommendation
}

const DECISION_ACTION_TYPES = new Set<RecommendationDecisionActionTypeDto>([
  'exclude_negative_keyword',
  'pause_entity',
  'run_impact_analysis',
  'review_manual',
  'no_action',
])

export function createRecommendationDecisionIntent(
  recommendation: Recommendation,
  accepted: boolean,
): RecommendationDecisionIntent {
  return {
    accepted,
    recommendation,
  }
}

/** Ground a UI decision in the published backend request without locale-authored wire text. */
export function toRecommendationDecisionRequest(
  thread: ChatThread,
  intent: RecommendationDecisionIntent,
): RecommendationDecisionRequestDto | null {
  const threadId = thread.threadId?.trim()
  if (!threadId) return null

  const body: RecommendationDecisionRequestDto = {
    thread_id: threadId,
    accepted: intent.accepted,
  }
  const conversationId = thread.conversationId?.trim()
  if (conversationId) body.conversation_id = conversationId

  const recommendationId = intent.recommendation.wire.recommendation_id?.trim()
  if (recommendationId) {
    body.recommendation_id = recommendationId
    return body
  }

  const entity = intent.recommendation.entity.trim()
  if (!entity) return null
  body.entity = entity
  const actionType = intent.recommendation.wire.action_type
  if (isDecisionActionType(actionType)) body.action_type = actionType
  return body
}

function isDecisionActionType(value: unknown): value is RecommendationDecisionActionTypeDto {
  return (
    typeof value === 'string' &&
    DECISION_ACTION_TYPES.has(value as RecommendationDecisionActionTypeDto)
  )
}
